// extracted by mini-css-extract-plugin
export const portfolio = "projects-module--portfolio--I0qeS";
export const projects = "projects-module--projects--RoR2i";